/* Casa Smart — interacciones (sin librerías) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.cs-reveal:not(.cs-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('cs-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('cs-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initCountUp() {
    var els = document.querySelectorAll('[data-cs-count]:not([data-cs-done])');
    if (!els.length) return;
    function run(el) {
      el.setAttribute('data-cs-done', '1');
      var target = parseFloat(el.getAttribute('data-cs-count')) || 0;
      var prefix = el.getAttribute('data-cs-prefix') || '';
      var suffix = el.getAttribute('data-cs-suffix') || '';
      var dur = parseInt(el.getAttribute('data-cs-duration'), 10) || 1600;
      if (reduce) { el.textContent = prefix + target + suffix; return; }
      var start = null;
      function step(t) {
        if (!start) start = t;
        var p = Math.min((t - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = prefix + Math.round(target * eased) + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { run(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initHeroTilt() {
    var frame = document.querySelector('.cs-hero__frame[data-cs-tilt]');
    if (!frame || reduce || window.matchMedia('(max-width: 989px)').matches) return;
    var strength = parseFloat(frame.getAttribute('data-cs-tilt')) || 6;
    var media = frame.parentElement;
    media.style.perspective = '1200px';
    media.addEventListener('mousemove', function (ev) {
      var r = media.getBoundingClientRect();
      var x = (ev.clientX - r.left) / r.width - 0.5;
      var y = (ev.clientY - r.top) / r.height - 0.5;
      frame.style.transform = 'rotateY(' + (x * strength) + 'deg) rotateX(' + (-y * strength) + 'deg)';
    });
    media.addEventListener('mouseleave', function () { frame.style.transform = ''; });
    frame.style.transition = 'transform 0.4s cubic-bezier(0.22, 1, 0.36, 1)';
  }

  function initStickyBuy() {
    var bar = document.querySelector('.cs-sticky-buy:not([data-cs-sticky-pdp])');
    if (!bar) return;
    var trigger = document.querySelector('.cs-hero') || document.body;
    function check() {
      var past = trigger.getBoundingClientRect().bottom < 0;
      bar.classList.toggle('cs-on', past);
    }
    window.addEventListener('scroll', check, { passive: true });
    check();
  }

  function money(cents) {
    var fmt = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CLP';
    try {
      return new Intl.NumberFormat('es-CL', { style: 'currency', currency: fmt, maximumFractionDigits: 0 }).format(cents / 100);
    } catch (e) { return '$' + Math.round(cents / 100); }
  }

  function initProduct() {
    var root = document.querySelector('[data-cs-product]');
    if (!root || root.getAttribute('data-cs-ready')) return;
    root.setAttribute('data-cs-ready', '1');

    // Galería
    var main = root.querySelector('[data-cs-main]');
    root.querySelectorAll('[data-cs-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (!main) return;
        main.src = t.getAttribute('data-cs-thumb');
        root.querySelectorAll('[data-cs-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });

    // Cantidad
    var qty = root.querySelector('input[name="quantity"]');
    root.querySelectorAll('[data-cs-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qty) return;
        var n = (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-cs-qty'), 10);
        qty.value = Math.max(1, n);
      });
    });

    // Variantes
    var add = root.querySelector('[data-cs-add]');
    var idInput = root.querySelector('[data-cs-variant-id]');
    var dataEl = root.querySelector('[data-cs-variants]');
    var sticky = document.querySelector('[data-cs-sticky-pdp]');
    if (dataEl) {
      var variants = JSON.parse(dataEl.textContent);
      root.addEventListener('change', function (ev) {
        if (!ev.target.matches('[data-cs-option]')) return;
        var sel = [];
        root.querySelectorAll('[data-cs-option]:checked').forEach(function (r) {
          sel[parseInt(r.getAttribute('data-cs-option'), 10)] = r.value;
        });
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
        if (!v) {
          add.disabled = true;
          add.textContent = add.getAttribute('data-soldout');
          return;
        }
        idInput.value = v.id;
        document.querySelectorAll('[data-cs-price]').forEach(function (p) { p.textContent = money(v.price); });
        var cmp = root.querySelector('[data-cs-compare]');
        var save = root.querySelector('[data-cs-save]');
        var on = v.compare_at_price && v.compare_at_price > v.price;
        if (cmp) { cmp.hidden = !on; if (on) cmp.textContent = money(v.compare_at_price); }
        if (save) {
          save.hidden = !on;
          var amt = save.querySelector('[data-cs-save-amount]');
          if (on && amt) amt.textContent = money(v.compare_at_price - v.price);
        }
        add.disabled = !v.available;
        add.textContent = v.available ? add.getAttribute('data-label') : add.getAttribute('data-soldout');
        if (v.featured_image && main) main.src = v.featured_image.src;
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      });
    }

    // Barra fija móvil
    if (sticky && add) {
      var stickyBtn = sticky.querySelector('[data-cs-sticky-add]');
      if (stickyBtn) stickyBtn.addEventListener('click', function () { add.click(); });
      var check = function () { sticky.classList.toggle('cs-on', add.getBoundingClientRect().bottom < 0); };
      window.addEventListener('scroll', check, { passive: true });
      check();
    }
  }

  // RUT chileno: formato 12.345.678-9 y dígito verificador
  function rutClean(v) { return (v || '').replace(/[^0-9kK]/g, '').toUpperCase(); }
  function rutValid(v) {
    var c = rutClean(v);
    if (c.length < 8 || c.length > 9) return false;
    var body = c.slice(0, -1), dv = c.slice(-1), sum = 0, mul = 2;
    for (var i = body.length - 1; i >= 0; i--) { sum += parseInt(body[i], 10) * mul; mul = mul === 7 ? 2 : mul + 1; }
    var r = 11 - (sum % 11);
    var exp = r === 11 ? '0' : r === 10 ? 'K' : String(r);
    return dv === exp;
  }
  function rutFormat(v) {
    var c = rutClean(v);
    if (c.length < 2) return c;
    var body = c.slice(0, -1).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return body + '-' + c.slice(-1);
  }
  function initRut() {
    var box = document.querySelector('[data-cs-rut]');
    if (!box || box.getAttribute('data-cs-ready')) return;
    box.setAttribute('data-cs-ready', '1');
    var input = box.querySelector('input');
    var msg = box.querySelector('[data-cs-rut-msg]');
    var helpText = msg ? msg.textContent : '';
    function show(ok) {
      box.classList.toggle('is-error', !ok);
      if (msg) msg.textContent = ok ? helpText : 'Revisa tu RUT: debe tener el formato 12.345.678-9 y un dígito verificador válido.';
      input.setCustomValidity(ok ? '' : 'RUT no válido');
    }
    input.addEventListener('input', function () {
      input.value = rutFormat(input.value);
      if (box.classList.contains('is-error') && rutValid(input.value)) show(true);
    });
    input.addEventListener('blur', function () { if (input.value) show(rutValid(input.value)); });
    document.addEventListener('click', function (ev) {
      var btn = ev.target.closest('#checkout, [name="checkout"]');
      if (!btn) return;
      if (!rutValid(input.value)) {
        ev.preventDefault();
        show(false);
        input.focus();
        input.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, true);
  }

  function initAll() {
    initRut();
    initReveal();
    initCountUp();
    initHeroTilt();
    initStickyBuy();
    initProduct();
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
